import { IApiClient } from '~/lib/ApiClient';
import { Vpc } from '../ApiModel';
import { IResourceSession } from './ResourceSession';
import { loadAllItems } from '../helper/PagingHelper';
import { IdResourceCollectionStore } from './ResourceCollectionStore';

export class VPCStore extends IdResourceCollectionStore<Vpc> {
    constructor(apiClient: IApiClient, session?: IResourceSession<Vpc>) {
        super({
            getItems: () => loadAllItems((link) => apiClient.getVPCs(link)),
            session: session,
        });
    }
}
